import { Box, makeStyles, Theme, Typography } from "@material-ui/core";
import React from "react";
import CheckIcon from '@material-ui/icons/Check';

const useStyles = makeStyles((theme: Theme) => ({
    
    divider: {
        [theme.breakpoints.up('md')]: {
            borderRight: '2px dashed',
            borderRightColor: theme.palette.grey[700],
            height: '70px',
        },
        [theme.breakpoints.down('sm')]: {
            flexBasis: '100%',
        },
    },
    withoutDivider: {
        [theme.breakpoints.down('sm')]: {
            flexBasis: '100%',
        },
    },
    grund: {
        display: 'flex',
        flexDirection: 'column',
        font: 'inherit',
        paddingRight: '20px',
    },
    titleRow: {
        fontFamily: theme.typography.subtitle1.fontFamily,
        fontSize: '22px',
        textTransform: 'uppercase',
        color: theme.palette.primary.main,
        fontWeight: 700
    },
    subtitle: {
        fontFamily: theme.typography.h6.fontFamily,
        fontSize: '14px',
        fontWeight: 700,
        color: theme.palette.grey[700],
        whiteSpace: 'nowrap'
    },
    checkIcon: {
        width: '24px',
        marginRight: '8px'
    }
}));

const Grund: React.FC<{title:string, subtitle:string, showDivider: boolean}> = ({title, subtitle, showDivider}) => {
    const classes = useStyles();
    return (
        <React.Fragment>
            <Box style={{display: 'flex', alignItems: 'center', justifyContent: 'center'}} className={showDivider ? classes.divider : classes.withoutDivider}>
                <Box className={classes.grund}>
                    <Box>
                        <Typography color='secondary' variant='h4' className={classes.titleRow}>
                            <Box component="span" style={{whiteSpace: 'nowrap'}}><CheckIcon className={classes.checkIcon} color='secondary'/>{title}</Box>
                        </Typography>
                    </Box>
                    <Box>
                        <Typography className={classes.subtitle}>{subtitle}</Typography>
                    </Box>
                </Box>
            </Box>
        </React.Fragment>
    );
}

export default Grund;